// extracted by mini-css-extract-plugin
module.exports = {"first-load":"CompetitorPricing_first-load__2v1bu","container":"CompetitorPricing_container__2Tgf5","loading":"CompetitorPricing_loading__2yB3k"};